import styled from 'styled-components';
import ListLoader from './component';

export default styled(ListLoader)`
  margin: 100px;
`;
